<template>
  <div class="cart-dropdown modal">
    <div class="wrapper">
      <button class="close" @click="closeCartDropdown">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>
      <div class="dropdown-content modal-content">
        <div class="container">
          <!-- Cart header -->

          <div class="cart-body">
            <!-- Cart items -->
            <div class="cart-items">
              <div class="header">
                <div class="header-left">
                  <div class="title extrasmall text-white">
                    {{ $t(`Your cart`) }}
                  </div>
                  <div class="count desc opacity-50">
                    ({{ cartContents.length }} {{ $t(`items`) }})
                  </div>
                </div>
                <div class="header-right">
                  <button class="clear" @click="handleClearCart">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g opacity="0.6">
                        <path
                          d="M3 6H21"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 11V17"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 11V17"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>

                    <span class="desc">{{ $t("Clear cart") }}</span>
                  </button>
                </div>
              </div>
              <div
                v-for="item in cartContents"
                :key="item.item?.id"
                class="cart-item"
              >
                <template v-if="item && item.item">
                  <div class="left">
                    <div class="item-image-container">
                      <img
                        :src="imgDomain + item.item.img_url"
                        class="item-image"
                      />
                    </div>

                    <div class="item-details">
                      <div class="item-type">{{ item.item.type }}</div>
                      <div class="item-title" :title="item.item.title">
                        {{ item.item.title }}
                      </div>
                    </div>
                    <div class="right">
                      <div class="item-price">
                        <span>{{ currencySymbol }}</span> {{ item.item.price }}
                      </div>
                    </div>
                    <button @click="handleDelete(item)" class="delete-item">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.667 4.66675C12.4902 4.66675 12.3206 4.73699 12.1956 4.86201C12.0706 4.98703 12.0003 5.1566 12.0003 5.33341V12.7941C11.9812 13.1312 11.8296 13.4471 11.5787 13.673C11.3277 13.8989 10.9976 14.0165 10.6603 14.0001H5.34033C5.00306 14.0165 4.67298 13.8989 4.422 13.673C4.17101 13.4471 4.01945 13.1312 4.00033 12.7941V5.33341C4.00033 5.1566 3.93009 4.98703 3.80506 4.86201C3.68004 4.73699 3.51047 4.66675 3.33366 4.66675C3.15685 4.66675 2.98728 4.73699 2.86225 4.86201C2.73723 4.98703 2.66699 5.1566 2.66699 5.33341V12.7941C2.68602 13.4849 2.97805 14.14 3.47911 14.616C3.98018 15.0919 4.64944 15.3499 5.34033 15.3334H10.6603C11.3512 15.3499 12.0205 15.0919 12.5215 14.616C13.0226 14.14 13.3146 13.4849 13.3337 12.7941V5.33341C13.3337 5.1566 13.2634 4.98703 13.1384 4.86201C13.0134 4.73699 12.8438 4.66675 12.667 4.66675Z"
                          fill="white"
                          fill-opacity="0.5"
                        />
                        <path
                          d="M13.3333 2.66675H10.6667V1.33341C10.6667 1.1566 10.5964 0.987034 10.4714 0.86201C10.3464 0.736986 10.1768 0.666748 10 0.666748H6C5.82319 0.666748 5.65362 0.736986 5.5286 0.86201C5.40357 0.987034 5.33333 1.1566 5.33333 1.33341V2.66675H2.66667C2.48986 2.66675 2.32029 2.73699 2.19526 2.86201C2.07024 2.98703 2 3.1566 2 3.33341C2 3.51023 2.07024 3.6798 2.19526 3.80482C2.32029 3.92984 2.48986 4.00008 2.66667 4.00008H13.3333C13.5101 4.00008 13.6797 3.92984 13.8047 3.80482C13.9298 3.6798 14 3.51023 14 3.33341C14 3.1566 13.9298 2.98703 13.8047 2.86201C13.6797 2.73699 13.5101 2.66675 13.3333 2.66675ZM6.66667 2.66675V2.00008H9.33333V2.66675H6.66667Z"
                          fill="white"
                          fill-opacity="0.5"
                        />
                        <path
                          d="M7.33333 11.3333V6.66667C7.33333 6.48986 7.2631 6.32029 7.13807 6.19526C7.01305 6.07024 6.84348 6 6.66667 6C6.48986 6 6.32029 6.07024 6.19526 6.19526C6.07024 6.32029 6 6.48986 6 6.66667V11.3333C6 11.5101 6.07024 11.6797 6.19526 11.8047C6.32029 11.9298 6.48986 12 6.66667 12C6.84348 12 7.01305 11.9298 7.13807 11.8047C7.2631 11.6797 7.33333 11.5101 7.33333 11.3333Z"
                          fill="white"
                          fill-opacity="0.5"
                        />
                        <path
                          d="M10.0003 11.3333V6.66667C10.0003 6.48986 9.93009 6.32029 9.80506 6.19526C9.68004 6.07024 9.51047 6 9.33366 6C9.15685 6 8.98728 6.07024 8.86225 6.19526C8.73723 6.32029 8.66699 6.48986 8.66699 6.66667V11.3333C8.66699 11.5101 8.73723 11.6797 8.86225 11.8047C8.98728 11.9298 9.15685 12 9.33366 12C9.51047 12 9.68004 11.9298 9.80506 11.8047C9.93009 11.6797 10.0003 11.5101 10.0003 11.3333Z"
                          fill="white"
                          fill-opacity="0.5"
                        />
                      </svg>
                    </button>
                  </div>
                </template>
              </div>
            </div>
            <!-- Total and actions -->
            <div class="footer">
              <!-- <label class="input-container input-container-stram">
                <input
                  v-model="steamId"
                  type="text"
                  required
                  :placeholder="$t('Steam ID')"
                />
              </label> -->
              <div class="total">
                <div class="total-title desc opacity-50 text-white">
                  <b>{{ $t(`TOTAL`) }}</b>
                </div>
                <div class="total-amount desc text-white">
                  <b>
                    {{ totalAmount }}
                    {{ currencySymbol }}
                  </b>
                </div>
              </div>

              <button
                class="button red w-130"
                @click="handleBuyButton"
                :disabled="isLoading"
              >
                <span>{{ $t("BUY") }}</span>
              </button>

              <div class="balance desc small">
                <div>{{ $t(`Your Balance:`) }}</div>
                <div class="balance-amount">
                  <div class="img-wrapper">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g opacity="0.6">
                        <path
                          d="M17 14H17.01"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="balance-box">
                    <b class="text-white desc"
                      ><span class="text-red">{{ currencySymbol }}</span>
                      {{ userBalance }}</b
                    >
                  </div>
                </div>
              </div>

              <!-- Not enough funds block -->
              <div class="funds-warning" v-if="userBalance < totalAmount">
                <div class="funds-warning-left">
                  <img
                    src="@/assets/img/exclamation.svg"
                    class="warning-icon"
                  />
                  <div class="warning-text">{{ $t(`Not enough funds!`) }}</div>
                </div>
                <div class="funds-warning-right">
                  <div class="warning-subtext">
                    <button @click="goToBalance" class="link">
                      {{ $t(`Top up balance`) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      steamId: "",
      imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
      isLoading: false,
    };
  },
  watch: {},
  mounted() {
    this.steamId = this.userData.steamId;
  },
  computed: {
    ...mapGetters("user", ["userData"]),
    ...mapGetters("user", ["userBalance"]),
    ...mapGetters("modals", ["cartDropdownIsVisible"]),
    ...mapGetters("cart", ["cartContents"]),
    currencySymbol() {
      return this.$store.getters["app/currencySymbol"];
    },
    totalAmount() {
      return this.cartContents
        .reduce((total, item) => total + parseFloat(item.item.price), 0)
        .toFixed(2);
    },
  },
  methods: {
    goToBalance() {
      this.closeCartDropdown();
      this.$router.push({ path: "/profile/balance" });
    },
    // ...mapActions('modals', ['closeCartDropdown']),
    ...mapActions("cart", ["removeFromCart", "fetchCartItems", "clearCart"]),
    ...mapActions("user", ["fetchUserData"]),
    closeCartDropdown() {
      this.$emit("close");
    },
    handleClearCart() {
      this.clearCart();
    },
    handleBuyButton() {
      this.$emit("openCartCheckout");
      // this.isLoading = true;
      // let data = {
      //   steamId: this.steamId,
      // };
      // this.$http
      //   .post(process.env.VUE_APP_API + "purchase/product", { data })
      //   .then((res) => {
      //     if (res.data.status == "OK") {
      //       this.closeCartDropdown();
      //       this.fetchCartItems();
      //       this.fetchUserData();
      //       this.$toast.success(this.$t("Purchase confirmed. Thanks"));
      //       this.$router.push({ path: "/profile/order-history" });
      //     } else {
      //       this.$toast.warning(this.$t(res.data?.message));
      //     }
      //     this.isLoading = false;
      //   })
      //   .catch((res) => {
      //     this.isLoading = false;
      //     this.$toast.error(this.$t(res.response?.data?.message));
      //   });
    },
    handleDelete(item) {
      const itemToRemove = { ...item, id: item?.item_id };
      this.removeFromCart(itemToRemove)
        .then(() => {})
        .catch((error) => {
          console.error("Failed to remove item:", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal .wrapper {
  max-width: 532px;
}
.modal .container {
  background: #191919;
  border: 1px solid #ffffff1a;
  padding: 32px;
  display: block;
}
.dropdown-content {
  position: relative;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 22px;

    .header-right {
      display: none;
    }
    .header-left {
      display: flex;
      align-items: baseline;
      gap: 16px;
    }
    .clear {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }
  .input-container-stram {
    display: block;
  }
  .cart-items {
    max-width: 100vw;
    flex: 1;

    .left,
    .right {
      display: flex;
      align-items: center;
      // gap: 5px;
    }

    .left {
      gap: 14px;
    }

    .right {
      flex: 0 0 107px;
    }

    .cart-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      width: 100%;
      border-radius: 12px;
      background: #070708;
      padding: 20px;

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      .item-image-container {
        width: 80px;
        min-width: 80px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        object-fit: contain;
      }
      .item-image {
        width: 80px;
        height: 60px;
        object-position: center;
        object-fit: contain;
        position: relative;
      }

      .item-details {
        padding-left: 10px;

        .item-type {
          font-family: "Roboto", sans-serif;
          font-size: 12px;
          line-height: 16px;
          color: #ffffff80;
        }

        .item-title {
          font-family: "Montserrat", sans-serif;
          font-size: 14px;
          color: #fff;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 200px;
          margin-top: 4px;
          line-height: 20px;
        }
      }

      .item-price {
        font-family: "Roboto", sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        text-wrap: nowrap;
        display: flex;
        flex: 1;
        justify-content: flex-end;
        gap: 6px;

        span {
          color: #eb001b;
        }
      }

      .delete-item {
        background: none;
        border: none;
        cursor: pointer;

        svg {
          width: 16px;
        }
      }
    }
  }

  .footer {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 32px;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 40px;
    }

    .balance-amount {
      width: 100%;
      padding: 0;
      display: flex;
      justify-content: center;
      margin-top: 10px;
      gap: 10px;

      .img-wrapper {
        line-height: 0;
      }
      .balance-box {
        align-items: center;
        justify-content: center;
        display: flex;
        gap: 10px;
      }
    }

    .total {
      display: flex;
      gap: 12px;

      .total-title {
        color: #fff;
      }
    }

    .balance {
      margin-top: 46px;
      flex-direction: column;
      gap: 12px;
      text-align: center;
      display: none;
    }

    .funds-warning {
      display: none;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(
        90deg,
        rgba(230, 11, 59, 0.3) 0%,
        rgba(230, 11, 59, 0) 100%
      );
      border-left: 1px solid #e60b3b;
      border-radius: 2px;
      font-size: 16px;
      font-weight: 700;
      font-family: "Roboto", sans-serif;
      margin-top: 18px;
      padding: 12px 0 12px 10px;
      border-radius: 8px;

      .warning-text {
        color: #e60b3b;
        line-height: 19px;
        font-size: 14px;
      }

      .warning-subtext {
        display: flex;
        color: #fff;

        .link {
          font-size: 12px;
          color: #15ca5c;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .warning-icon {
        margin-right: 16px;
      }
    }
    .funds-warning-left {
      display: flex;
      align-items: center;
    }
  }
  .button.green {
    width: 100%;
  }

  .modal-button-wrapper {
    min-width: 80px;
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 900px) {
  .cart-body {
    flex-direction: column;

    .cart-items {
      padding-right: 0;
      border: 0;
    }
    .footer {
      padding-left: 0;
      margin-top: 32px;
    }
  }
  .dropdown-content .cart-items .cart-item {
    flex-wrap: wrap;
  }
  .modal .container {
    padding: 42px 16px;
  }
  .dropdown-content .footer .balance {
    margin-top: 24px;
  }
  .dropdown-content .cart-items .left {
    flex-wrap: wrap;
  }
}
</style>
